import { useQuery } from '@tanstack/react-query';
import { tokenInspectorApi } from '../api/tokenInspectorApi';
import type { RefreshHistoryView } from '../types/tokenInspector.types';

/**
 * Query: GET /api/eraf/dev/token-inspector/refresh-history?userId=...&size=20
 * Only fetches when enabled=true (user has submitted a userId).
 */
export function useRefreshHistory(userId: number, enabled: boolean) {
  return useQuery<RefreshHistoryView, { code: string; message: string }>({
    queryKey: ['tokenInspector', 'refresh', userId],
    queryFn: () => tokenInspectorApi.getRefreshHistory(userId),
    enabled: enabled && userId > 0,
    retry: false,
    staleTime: 0,
  });
}
